import createWasteProduct from ".";
import createEditWasteProduct from "./EditWasteProduct";
import { wasteProductRoutes } from "./routes";

export const createWasteProductPage = () => {
    const List = createWasteProduct();
    const Edit = createEditWasteProduct();

    const WasteProductPage = wasteProductRoutes;
    return () => (
        <WasteProductPage
            List={List}
            Edit={Edit}
        />
    );
};

